module.exports = __webpack_public_path__ + "media/images/voice08-2-14a5afa33d975245f15cb036643fbea2.jpg";